import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaFilm,
  FaEye,
  FaRocket,
  FaStar,
  FaUsers,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ShortFilmProductionCompanyInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Short Film Production Company in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Tell Your Story</Subheading>}
        heading={
          <Heading>
            Premier <span tw="text-primary-500">Short Film Production</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we are a leading short film production company in
            **Dubai**, crafting compelling, cinematic stories that captivate
            audiences and leave a lasting impact. Bring your vision to life with
            our expert filmmakers.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1599240211563-17590b1af857?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Film production
          "https://images.unsplash.com/photo-1578221569814-fd71a9718db5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Camera crew
          "https://images.unsplash.com/photo-1602491453631-e2a5ad90a131?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Editing suite
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Film"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Short Film Production in Dubai"
        description="We create cinematic short films with passion and precision."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Excellence",
            description: "High-quality visuals for stunning storytelling.",
          },
          {
            icon: <FaFilm color="#ff5464" size={40} />,
            title: "Creative Direction",
            description: "Unique narratives tailored to your vision.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Audience Impact",
            description: "Films that resonate and engage viewers.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Efficient Production",
            description: "Timely delivery with professional standards.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Collaborative Team",
            description: "Skilled crew dedicated to your project.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in Dubai",
            description: "Preferred choice for short film production.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Cinematic Production Process"
        description={
          <Description>
            We produce short films with a meticulous approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Concept Development: Collaborate to shape your story.</li>
              <li>Scriptwriting: Craft compelling scripts and storyboards.</li>
              <li>Filming: Capture scenes with state-of-the-art equipment.</li>
              <li>
                Post-Production: Edit with precision, adding effects and sound.
              </li>
              <li>Review: Refine to align with your creative vision.</li>
              <li>Delivery: Present a polished film ready for screening.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1533928298208-27ff66555d8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Film production
          "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Camera crew
          "https://images.unsplash.com/photo-1543536448-1e76fc2795bf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Editing suite
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Cinematic Achievements in Dubai"
        description="Our short films have inspired and impressed."
        cards={[
          {
            icon: <FaFilm color="#ff5464" size={40} />,
            title: "Award-Winning Films",
            description: "Recognized at regional film festivals.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Global Reach",
            description: "Films showcased to international audiences.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "98% satisfaction from filmmakers and brands.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Create Your Film?</Subheading>}
        heading="Short Film Production in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset, Dubai’s premier short film production
            company. Turn your story into a cinematic masterpiece—contact us
            today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1523207911345-32501502db22?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Camera crew
          "https://images.unsplash.com/photo-1501369762096-edcbbcf4ad81?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Editing suite
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Film production
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
